import React from "react";
import { AccountingReportFilters } from "@components/accounting/types";
import { journalEntrySourceFilterToLabelMap } from "@components/accounting/constants";

export const JournalEntrySourceFilterLabel: React.FC<{
    filters: AccountingReportFilters;
}> = ({ filters }) => {
    const values = filters.journalEntrySources ?? [];

    if (values.length === 0) {
        return null;
    }

    if (values.length === 1) {
        return <>{journalEntrySourceFilterToLabelMap[values[0]]}</>;
    }

    return `${values.length} sources`;
};
